export const AUTH_APP_LOCALE_LOCAL_STORAGE_KEY = 'milanote.auth.appLocale';

export const AUTH_LOCALE_ROUTE_PATHS = new Set([
    '/login',
    '/register',
    '/app-login',
    '/app-register',
    '/register-confirm',
]);
